"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _util = require("../util");
var _environment = _interopRequireDefault(require("../environment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var config = Object.assign({}, _environment.default.CONFIG);
var apiService = function apiService(_ref) {
  var getState = _ref.getState;
  return function (next) {
    return function (action) {
      var result = next(action);
      config = _environment.default.ADD_AUTH_HEADER(config, getState().auth);

      // also add headers coming from the request
      if (action.meta && action.meta.headers) {
        config.headers = Object.assign({}, config.headers, action.meta.headers);
      }

      //add api version header coming from the request
      if (action.meta) {
        config = _environment.default.ADD_VERSION_HEADER(config, action.meta);
      }
      if (!action.meta || !action.meta.async) {
        return result;
      }
      var _action$meta = action.meta,
        url = _action$meta.url,
        _action$meta$method = _action$meta.method,
        method = _action$meta$method === void 0 ? 'GET' : _action$meta$method,
        body = _action$meta.body;
      if (!url) {
        throw new Error("'url' not specified for async action ".concat(action.type));
      }
      config.method = method;
      return (0, _util.fetch)(url, method, body, config).then(function (res) {
        return handleResponse(res, action, next);
      }, function (err) {
        return handleErrors(err, action, next);
      }).catch(function (err) {
        return void 0;
      });
    };
  };
};
var _default = exports.default = apiService;
function handleErrors(err, action, next) {
  var ACTION_TYPE = action.type.replace('REQUEST', 'FAILURE');
  var error = {
    response: {
      error: {
        code: '-1',
        statusCode: '-1',
        message: 'Request failed'
      }
    }
  };
  try {
    if (Object.keys(err).length !== 0 && err.constructor === Object) {
      error.response.error.message = err;
    }
    //console.log(`Error object: ${JSON.stringify(err)}`);
    //const errorJson = JSON.stringify(err.json());
    //console.log(`Error json: ${errorJson}`);
    //defaultError =
  } catch (err) {}
  if (err.hasOwnProperty('message')) {
    error.response.error.message = JSON.parse(err.message).message;
    error.response.error.statusCode = JSON.parse(err.message).statusCode;
  }
  next({
    type: ACTION_TYPE,
    payload: error,
    meta: action.meta
  });
  throw Error(error);
  //return Promise.reject(err.json());
}
function handleResponse(res, action, next) {
  var ACTION_TYPE = action.type.replace('REQUEST', 'SUCCESS');
  next({
    type: ACTION_TYPE,
    payload: res,
    meta: action.meta
  });
  return res;
}